import { motion } from 'framer-motion';
import { BookOpen, Calendar, Clock, ArrowRight, Construction } from 'lucide-react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export const BlogWindow = () => {
  /* Commented out article data
  const articles = [
    {
      title: 'Building Scalable Microservices with Kubernetes',
      excerpt: 'A comprehensive guide to designing and deploying microservices architecture using Kubernetes, Docker, and cloud-native technologies...',
      date: '2024-03-15',
      readTime: '8 min read',
      category: 'DevOps',
      tags: ['Kubernetes', 'Docker', 'Microservices']
    },
    {
      title: 'Advanced React Patterns for Large Applications',
      excerpt: 'Explore advanced React patterns including compound components, render props, and custom hooks to build maintainable large-scale applications...',
      date: '2024-03-10',
      readTime: '12 min read',
      category: 'Frontend',
      tags: ['React', 'JavaScript', 'Architecture']
    },
    {
      title: 'Machine Learning Model Deployment Best Practices',
      excerpt: 'Learn how to deploy machine learning models to production with proper monitoring, versioning, and automated retraining pipelines...',
      date: '2024-03-05',
      readTime: '10 min read',
      category: 'AI/ML',
      tags: ['Machine Learning', 'MLOps', 'Python']
    },
    {
      title: 'Optimizing Database Performance at Scale',
      excerpt: 'Discover techniques for optimizing database queries, indexing strategies, and caching mechanisms to handle millions of requests...',
      date: '2024-02-28',
      readTime: '15 min read',
      category: 'Backend',
      tags: ['PostgreSQL', 'Performance', 'Database']
    },
    {
      title: 'Building Real-time Applications with WebSocket',
      excerpt: 'A deep dive into WebSocket technology, implementing real-time features, and handling connection management at scale...',
      date: '2024-02-20',
      readTime: '9 min read',
      category: 'Backend',
      tags: ['WebSocket', 'Node.js', 'Real-time']
    },
    {
      title: 'TypeScript Best Practices for 2024',
      excerpt: 'Modern TypeScript patterns, advanced type utilities, and techniques to write type-safe, maintainable code...',
      date: '2024-02-15',
      readTime: '7 min read',
      category: 'Frontend',
      tags: ['TypeScript', 'JavaScript', 'Best Practices']
    }
  ];
  */

  return (
    <div className="space-y-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-4xl font-bold glow-text mb-2">Technical Blog</h1>
        <p className="text-muted-foreground">Insights, tutorials, and thoughts on technology</p>
      </motion.div>

      {/* Coming Soon Section */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="flex flex-col items-center justify-center py-20 text-center"
      >
        <div className="p-6 rounded-full bg-accent/10 mb-6">
          <Construction className="w-16 h-16 text-accent animate-bounce" />
        </div>
        <h2 className="text-5xl font-bold mb-4 glow-text">Coming Soon</h2>
        <p className="text-muted-foreground max-w-md">
          I'm currently drafting articles about live sound engineering, event logistics, and full-stack development. Check back soon for the first post!
        </p>
      </motion.div>

      {/* Featured Article - Commented Out
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <Card className="p-8 tech-border bg-gradient-to-br from-primary/5 to-accent/5">
          <Badge className="mb-4">Featured</Badge>
          <h2 className="text-3xl font-bold glow-text mb-3">{articles[0].title}</h2>
          ...
        </Card>
      </motion.div>
      */}

      {/* Recent Articles - Commented Out
      <div className="space-y-4 opacity-20 pointer-events-none">
        <h2 className="text-2xl font-bold text-primary">Recent Articles</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          ...
        </div>
      </div>
      */}

      {/* Stats - Commented Out
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
      >
        <Card className="p-6 tech-border">
          <div className="grid grid-cols-4 gap-6 text-center">
            ...
          </div>
        </Card>
      </motion.div>
      */}
    </div>
  );
};

export default BlogWindow;